"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/logo--facebook/16.js"));
var _2 = _interopRequireDefault(require("@carbon/icons-react/lib/logo--linkedin/16.js"));
var _3 = _interopRequireDefault(require("@carbon/icons-react/lib/logo--x/16.js"));
var _4 = _interopRequireDefault(require("@carbon/icons-react/lib/logo--youtube/16.js"));
var _5 = _interopRequireDefault(require("@carbon/icons-react/lib/logo--instagram/16.js"));
var _6 = _interopRequireDefault(require("@carbon/icons-react/lib/logo--xing/16.js"));
var _7 = _interopRequireDefault(require("@carbon/icons-react/lib/help/16.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Icon = {
  facebook: _.default,
  linkedin: _2.default,
  x: _3.default,
  twitter: _3.default,
  youtube: _4.default,
  instagram: _5.default,
  xing: _6.default
};
const SocialNetworkLogo = _ref => {
  let {
    socialNewtwork
  } = _ref;
  const SelectedIcon = Icon[socialNewtwork] || _7.default;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'socialNetworkLogo'
  }, /*#__PURE__*/_react.default.createElement(SelectedIcon, null));
};
var _default = exports.default = SocialNetworkLogo;